import { AnnounceItem } from './type';
import { util, CustomException, language } from '@tencent/ppd-base-libs';
import { AnnounceItemRaw, qryLoopData } from './api';

/**
 * 获取数据，筛选数据，格式化数据
 */
export async function getAnnounceData(dataUrl: string): Promise<AnnounceItem[]> {
  // 获取数据
  const [error, res] = await util.to(qryLoopData(dataUrl));

  if (error) {
    // 静默处理
    new CustomException(error, 'LoopAnnounceException', `qryLoopData failed for url: ${dataUrl}`);
    return [];
  }

  // 筛选数据，格式化数据
  const curTime = +new Date();
  const lang = getLanguageMap();
  const result = res.filter((item: AnnounceItemRaw) => {
    const startTime = +new Date(item.startTime.replace(/-/g, '/'));
    const endTime = +new Date(item.endTime.replace(/-/g, '/'));

    return curTime > startTime && curTime < endTime;
  }).sort((a, b) => b.weight - a.weight)
    .map((item: AnnounceItemRaw) => ({
      icon: item.icon ?? '',
      text: item[`${lang}Text`]?.trim(),
      biTag: item.biTag ?? '',
    }));

  return filterData(result);
}

/**
 * 过滤不符合规范的数据，避免认为错误
 * text不能为空
 */
export function filterData(data: AnnounceItem[]): AnnounceItem[] {
  return data.filter((item: AnnounceItem) => !!item.text);
}

function getLanguageMap(): string {
  const langMap = {
    zh_cn: 'cn',
    zh_hk: 'hk',
    zh_tw: 'hk',
  };
  const lang = language.getLanguage().toLowerCase()
    .replace(/-/g, '_');

  return langMap[lang] || 'en';
}
